import { render, staticRenderFns, recyclableRender, components } from "./t-index-address.vue?vue&type=template&id=38cbf0c2&scoped=true&"
var renderjs
import script from "./t-index-address.vue?vue&type=script&lang=js&"
export * from "./t-index-address.vue?vue&type=script&lang=js&"
import style0 from "./t-index-address.vue?vue&type=style&index=0&id=38cbf0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cbf0c2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/t-index-address/components/t-index-address/t-index-address.vue"
export default component.exports